export default __webpack_public_path__ + "apple-touch-icon.a1b3f109.png";